import { makeStyles } from '@material-ui/core/styles'
import { createStyles, Theme } from '@material-ui/core'

export const useAccountLayoutStyle = makeStyles((theme: Theme) =>
  createStyles({
    contentHolder: {
      paddingTop: theme.spacing(5),
      paddingBottom: theme.spacing(8),
      minHeight: 'calc(100vh - 200px)',
      [theme.breakpoints.down('sm')]: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(4),
      },
    },
  })
)
